/* First message is rendered by Liquid; rotation never changes the header height. */
if (!customElements.get('khs-mission-ticker')) {
  customElements.define('khs-mission-ticker', class extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('[data-ticker-message]')];
      this.position = this.querySelector('[data-ticker-position]');
      this.pauseButton = this.querySelector('[data-ticker-pause]');
      this.index = 0;
      this.userPaused = false;
      this.editorPaused = false;
      this.hovered = false;
      this.events = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
      const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: this.events.signal });
      listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => this.stop());
      listen(this, 'focusout', (event) => { if (!this.contains(event.relatedTarget)) this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.motion, 'change', () => { if (this.motion.matches) this.show(0); this.schedule(); });
      listen(this, 'shopify:block:select', (event) => {
        const index = this.messages.findIndex(message => message.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.editorPaused = true;
        this.show(index);
        this.stop();
      });
      listen(this, 'shopify:block:deselect', () => { this.editorPaused = false; this.schedule(); });
      if (this.pauseButton) listen(this.pauseButton, 'click', () => {
        this.userPaused = !this.userPaused;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.setAttribute('aria-label', this.userPaused ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('[data-ticker-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
        this.schedule();
      });
      this.schedule();
    }
    disconnectedCallback() {
      this.stop();
      this.events?.abort();
    }
    stop() {
      clearTimeout(this.timer);
      this.timer = null;
    }
    schedule() {
      this.stop();
      const canRotate = this.messages.length > 1 && this.dataset.static !== 'true' && !this.motion.matches;
      if (this.pauseButton) this.pauseButton.hidden = !canRotate;
      if (!canRotate || this.userPaused || this.editorPaused || document.hidden || this.contains(document.activeElement) || (this.dataset.hover === 'true' && this.hovered)) return;
      this.timer = setTimeout(() => { this.show((this.index + 1) % this.messages.length); this.schedule(); }, this.interval);
    }
    show(index) {
      this.index = index;
      this.messages.forEach((message, current) => {
        message.hidden = current !== index;
        message.classList.toggle('is-entering', current === index && !this.motion.matches);
      });
      if (this.position) this.position.textContent = String(index + 1).padStart(2, '0');
    }
  });
}
